import { $win, getCurrentDevice } from './utils';
import moment from 'moment';
import Pikaday from 'pikaday';

const initDatepickers = () => {
	const format = 'MM/DD/YYYY';
	const $datepickers = $('.js-datepickers');
	let isKeyboard = false;

	$datepickers.each((index, el) => {
		const $datepicker = $(el);
		const fieldStart = el.querySelector('.js-datepicker-start');
		const fieldEnd = el.querySelector('.js-datepicker-end');
		if (!fieldStart) {
			return;
		}
		const containerStart = $(fieldStart).closest('.js-datepicker-container')
		const containerEnd = $(fieldEnd).closest('.js-datepicker-container')
		let startDate, endDate;
		const options = {
			minDate: new Date(),
			keyboardInput: false,
			bound: true,
			format,
			numberOfMonths: 1,
			theme: 'pikaday-bm',
			i18n: {
				months        : moment.months(),
				weekdays      : moment.weekdays(),
				weekdaysShort : moment.weekdaysShort()
			}
		}
		function eqRows(calendar) {
			const $tables = $datepicker.find('table');
			$tables.each(function() {
				const $body = $(this).find('tbody');
				const $rows = $body.find('tr');
				if ( $rows.length < 6 ) {
					$body.append($('<tr class="pika-row"><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td></tr>'));
				}
			});
		}
		const updateStartDate = () => {
			startPicker.setStartRange(startDate);
			endPicker.setStartRange(startDate);
			endDate = moment(startDate).add('1','day')._d;
			endPicker.setMinDate(startDate);
			endPicker.setDate(endDate);
			startPicker.setEndRange(endDate);
			startPicker.hide();
			endPicker.show();
		}
		const updateEndDate = () => {
			startPicker.setEndRange(endDate);
			endPicker.setEndRange(endDate);
			endPicker.draw();
			endPicker.hide();
		}
		const startPicker = new Pikaday({
			field: fieldStart,
			container: containerStart[0],
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					startDate = this.getDate();
					updateStartDate();
					setTimeout(function() {
						const nextDate = moment(startDate).add(1, 'days');
						const selectedMonth = nextDate.month();
						const selectedYear = nextDate.year();
						$(fieldEnd).val(nextDate.format(format));
						endPicker.setEndRange(startDate._d);
						endPicker.gotoMonth(selectedMonth);
						endPicker.gotoYear(selectedYear);
						$(fieldEnd).focus();
					}, 10);
				}
			},
			onDraw: function() {
				eqRows(this);
			}
		});
		const endPicker = new Pikaday({
			field: fieldEnd,
			container: containerEnd[0],
			...options,
			onSelect: function() {
				if ( !isKeyboard ) {
					endDate = this.getDate();
					updateEndDate();
				}
			},
			onDraw: function() {
				eqRows(this);
			}
		});
		const _startDate = startPicker.getDate();
		const _endDate = endPicker.getDate();
		if (_startDate) {
			startDate = _startDate;
			updateStartDate();
		}
		if (_endDate) {
			endDate = _endDate;
			updateEndDate();
		}
		$(fieldStart).on('input', function(event) {
			const code = event.keyCode;
			if ( code != 37 && code != 38 && code != 39 && code != 40 ) {
				manualFormat(this);
			}
		})
		$(fieldEnd).on('input', function(event) {
			const code = event.keyCode;
			if ( code != 37 && code != 38 && code != 39 && code != 40 ) {
				manualFormat(this);
			}
		})
	});
}

export function manualFormat(input) {
	let value = input.value;
	if (/\D\/$/.test(value)) {
		value = value.substr(0, value.length - 3);
	}
	let values = value.split('/').map(function(v) {
		return v.replace(/\D/g, '')
	});
	if (values[0]) {
		values[0] = checkValue(values[0], 31);
	}
	if (values[1]) {
		values[1] = checkValue(values[1], 12);
	}
	const output = values.map(function(item, index) {
		return item.length == 2 && index < 2 ? item + ' / ' : item;
	});
	value = output.join('').substr(0, 14);
	input.value = value;
}

function checkValue(str, max) {
	if (str.charAt(0) !== '0' || str == '00') {
		let num = parseInt(str);
		if (isNaN(num) || num <= 0 || num > max) {
			num = 1;
		}
		str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
	};
	return str;
};

const initDatepickerSingle = () => {
	const $datepicker = $('.js-datepicker-single');

	$datepicker.each((index, field) => {
		const datepicker = new Pikaday({
			minDate: new Date(),
			field,
			format: 'MM/DD/YYYY',
			bound: true,
			container: field.parentNode,
			theme: 'pikaday-bm',
			i18n: {
				months        : moment.months(),
				weekdays      : moment.weekdays(),
				weekdaysShort : moment.weekdaysShort()
			}
		});

		initManualFormat(field);
	});
}

const initManualFormat = (field) => {
	$(field).on('input', function(event) {
		const code = event.keyCode;

		if ( code != 37 && code != 38 && code != 39 && code != 40 ) {
			manualFormat(this);
		}
	});
}

export default function datepickersDefaultUI() {
	initDatepickers();

	initDatepickerSingle();
}
